//Proceso para encriptar prudential
import * as openpgp from 'openpgp';


export const encryptPruCard = async (cardNumber) => {
    try {
        const publicArmoredKey = `-----BEGIN PGP PUBLIC KEY BLOCK-----

mQENBFiI8l0BCADIrK/m06Z8t7wG/i0qzYo7bIVH5mWDgN3+yrt9WXffeHFbyChr
AbX9Wfad0fcGahp2Y1FzaloqpakFCgL6fO7QpLb4hcyZAjwV8stJjZPiLN1OFI3o
4tKao6SqUJJyWYyGkkFg7Jci1cYBA7mGv1W2tw1FHEYc9ZOmNsstMvIWQ69XYfxE
o9eyKA+YKp4y6zM3kBShnXG1oCcQE0zs7Q4vLA6Cm1D2+PROyUSTc4MEt6JPqWvR
aIYj29+sLRPOxNcAUunwo0NPHH5G1WV4X4lfxUSwT+cbuqnC18+VR3mLcBVmdRUx
pFwWkQffh5zOrG7zZqPsv0cICAzlb/1z9uqZABEBAAG0HkdpcmVQQ0kgPGFibV9z
ZWdpbmZvQGdpcmUuY29tPokBOQQTAQgAIwUCWIjyXQIbAwcLCQgHAwIBBhUIAgkK
CwQWAgMBAh4BAheAAAoJEFofvXIt0fTu0MwH/RFBJQSMlI2Rt04cckXMVM++mwXL
SaWly668UiuwYO2eN/Sekvgyniw6lUDlmaC8ekC7+l3JOuYefizHjsvdW2xKg702
qs4G50MrQkhjl6mJhdGSSq2IpJmH61B1dXCFhBj5vb11Ej448vX4/yxkpt+1naIO
K2l2L5gqtl1tvfP75wJ03HTiaCwj2gNPjyQT9yYAgknoMLsBOwqd+jhXyjj1BQGx
P/BtnVIzq4AvB4IdDips1EejlQZbxRQKEFZDL15g4ckgoK9F9Zv6A/gOAf/WNpO5
FOM2DqLIgY8D1rL5TtO7TrfEVO2kbFj9VU4pDwYctddnY53NSM8jXYW70xi5AQ0E
WIjyXQEIAO478YDxDXjY9iYnBlRip1E684SPCO4ylPtLhsrkZpMVYelovxayV3x4
tyXE4dw4gmlVnQotuUux1GXfI65ytSUyeWUcXoGfB246Wx0ZmvVVcE5eATVkhuye
lA0wctOH2t0UW3Z3TxfGw698sy3KyCMh41wpj9HI4fLFUoIXpl7l+NKm9b0x1NKm
iGOP0AcTNQv8L4pj1Riba587vcm757946vpu7GDYyTneM4F+UY5gRaqSJImYRN/1
n7LFrMHoi7Cb2EW5kmUaDbLnHlaKmi6QIqq+paB0mp755nQRH3Qa1wkKjKGaqyfW
nE3IAKabJDYWngeG5/dj9zUuc6hNjrMAEQEAAYkBHwQYAQgACQUCWIjyXQIbDAAK
CRBaH71yLdH07pEUB/0b2e/YAEhZlHxJT1fvNDFvSb+Xb/bzuQJgsTB3Fy8rr/VT
SU6HADMdyQsftGA7e0cSin6wBegQsPE0eJvJwmXQuIJIiK/3nnuMdHGd57bL5kdt
UznRcLxbieAYWlV03T9+Y9k2DtKI4ZIKPaHg1OqfagPuQdryAaoBdFiCjuPGb7ug
hmmgB1BJJbfjCmvC42sRDwCTCzyc98v2mLv6EjG5GSllhKCiwbibbKZX6LZ+xYBo
YNjOMCTLs4ZRYIfNCu7MNhk2UkXba6F3obCRAN7JyijiunnZu7lvKJtknFY6WkMf
U1zUpjglkI9XwPzEcyP9Gt9sNhkl63z6WIFEoo6j
=5Z8U

-----END PGP PUBLIC KEY BLOCK-----`;
        const publicKey = await openpgp.readKey({ armoredKey: publicArmoredKey });

        const text = cardNumber.replaceAll(" ", "")

        const cryptOptions = {
            message: await openpgp.createMessage({ text }),
            encryptionKeys: publicKey,
        };

        const tarPGP = await openpgp.encrypt(cryptOptions);

        const regex = /-----BEGIN PGP MESSAGE-----\n([\s\S]+)\n=.*\n-----END PGP MESSAGE-----/;
        const coincidencias = tarPGP.match(regex);
        const encryptedTar = coincidencias[1];
        return encryptedTar.trim().replace(/\n/g, '');
    } catch (err) {
        console.error("Error en tokenizado");
    };
};


